import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CampaignMiniBanner from '../../components/feature/CampaignMiniBanner';

const accessoriesData = [
  {
    id: 'headrest-4d',
    name: '4Dヘッドレスト',
    description: 'MeVER Chair Core専用の4Dヘッドレスト。上下・前後・角度・回転の4方向調整で、首と頭をしっかりサポートします。長時間のデスクワークでも首への負担を軽減。',
    price: '¥4,950',
    priceGray: '¥6,050',
    originalPrice: null,
    image: 'https://public.readdy.ai/ai/img_res/aa32e8430d9f5be45809fbd71d112213.jpg',
    compatibility: ['MeVER Chair Core'],
    features: [
      { icon: 'ri-arrow-up-down-line', title: '上下調整', desc: '高さを自由に調整可能' },
      { icon: 'ri-arrow-left-right-line', title: '前後調整', desc: '奥行きを調整可能' },
      { icon: 'ri-rotate-lock-line', title: '角度調整', desc: '前後の角度を調整' },
      { icon: 'ri-refresh-line', title: '回転調整', desc: '左右の回転が可能' },
    ],
    specs: [
      { label: '対応モデル', value: 'MeVER Chair Core' },
      { label: '素材', value: 'メッシュ + 樹脂フレーム' },
      { label: '調整方向', value: '4D（上下・前後・角度・回転）' },
      { label: '調整範囲（高さ）', value: '8cm' },
      { label: '調整範囲（角度）', value: '30°' },
      { label: '重量', value: '0.8kg' },
      { label: '保証期間', value: '1年' },
    ],
    status: '在庫あり',
    badge: 'おすすめ',
  },
  {
    id: 'lumbar-cushion',
    name: 'ランバーサポートクッション',
    description: '追加のランバーサポートで腰への負担をさらに軽減。低反発素材を使用し、長時間座っていても快適な座り心地を維持します。',
    price: '¥8,800',
    priceGray: null,
    originalPrice: null,
    image: 'https://readdy.ai/api/search-image?query=ergonomic%20lumbar%20support%20cushion%20for%20office%20chair%20black%20memory%20foam%20back%20support%20pillow%20isolated%20on%20pure%20white%20background%20professional%20product%20photography%20clean%20modern%20design&width=600&height=600&seq=lumbar001&orientation=squarish',
    compatibility: ['MeVER Chair Pro', 'MeVER Chair Core', 'MeVER Chair Style'],
    features: [
      { icon: 'ri-heart-pulse-line', title: '低反発素材', desc: '体圧を分散' },
      { icon: 'ri-shield-check-line', title: '腰椎サポート', desc: '自然なカーブを維持' },
      { icon: 'ri-t-shirt-line', title: '通気性カバー', desc: '取り外し洗濯可能' },
      { icon: 'ri-link', title: '固定ベルト付き', desc: 'ズレを防止' },
    ],
    specs: [
      { label: '対応モデル', value: '全モデル対応' },
      { label: '素材', value: '低反発ウレタン' },
      { label: 'サイズ', value: '35×30×10cm' },
      { label: 'カバー素材', value: 'メッシュファブリック' },
      { label: '重量', value: '0.5kg' },
      { label: '保証期間', value: '1年' },
    ],
    status: '在庫あり',
    badge: null,
  },
  {
    id: 'armrest-pad',
    name: 'アームレストパッド',
    description: 'アームレストに取り付けるソフトパッド。低反発素材で肘への負担を軽減し、長時間のタイピングやマウス操作をサポートします。',
    price: '¥4,800',
    priceGray: null,
    originalPrice: null,
    image: 'https://readdy.ai/api/search-image?query=ergonomic%20armrest%20pad%20cushion%20for%20office%20chair%20black%20memory%20foam%20elbow%20support%20pair%20isolated%20on%20pure%20white%20background%20professional%20product%20photography%20clean%20modern%20design&width=600&height=600&seq=armrest001&orientation=squarish',
    compatibility: ['MeVER Chair Pro', 'MeVER Chair Core'],
    features: [
      { icon: 'ri-hand-heart-line', title: '低反発クッション', desc: '肘への負担を軽減' },
      { icon: 'ri-sticky-note-line', title: '滑り止め加工', desc: 'ズレにくい設計' },
      { icon: 'ri-drop-line', title: '防水カバー', desc: '汚れに強い素材' },
      { icon: 'ri-scissors-line', title: 'カット可能', desc: 'サイズ調整可能' },
    ],
    specs: [
      { label: '対応モデル', value: 'Pro / Core' },
      { label: '素材', value: '低反発ウレタン' },
      { label: 'サイズ', value: '25×8×3cm（1個）' },
      { label: '内容', value: '2個セット' },
      { label: '重量', value: '0.2kg（2個）' },
      { label: '保証期間', value: '6ヶ月' },
    ],
    status: '在庫あり',
    badge: null,
  },
  {
    id: 'caster-set',
    name: '静音キャスターセット',
    description: 'フローリングに優しい静音キャスター。ポリウレタン素材で床を傷つけず、スムーズな移動を実現します。5個セット。',
    price: '¥6,800',
    priceGray: null,
    originalPrice: '¥8,500',
    image: 'https://readdy.ai/api/search-image?query=office%20chair%20caster%20wheels%20set%20of%20five%20black%20polyurethane%20silent%20smooth%20rolling%20isolated%20on%20pure%20white%20background%20professional%20product%20photography%20clean%20modern%20design&width=600&height=600&seq=caster001&orientation=squarish',
    compatibility: ['MeVER Chair Pro', 'MeVER Chair Core', 'MeVER Chair Style'],
    features: [
      { icon: 'ri-volume-mute-line', title: '静音設計', desc: '音を気にせず移動' },
      { icon: 'ri-home-line', title: '床に優しい', desc: 'フローリング対応' },
      { icon: 'ri-refresh-line', title: 'スムーズ回転', desc: '360°回転' },
      { icon: 'ri-lock-line', title: 'ロック機能', desc: '固定可能' },
    ],
    specs: [
      { label: '対応モデル', value: '全モデル対応' },
      { label: '素材', value: 'ポリウレタン' },
      { label: '直径', value: '65mm' },
      { label: '内容', value: '5個セット' },
      { label: '耐荷重', value: '150kg（5個合計）' },
      { label: '保証期間', value: '1年' },
    ],
    status: '在庫あり',
    badge: 'セール',
  },
];

export default function AccessoriesPage() {
  const [scrolled, setScrolled] = useState(false);
  const [selectedAccessory, setSelectedAccessory] = useState(accessoriesData[0]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative">
      <Navbar scrolled={scrolled} />
      <div className="pt-16 sm:pt-20">
        <CampaignMiniBanner />
      </div>

      {/* Hero */}
      <section className="pt-8 sm:pt-12 pb-12 sm:pb-16 bg-gradient-to-b from-gray-50 to-white" aria-labelledby="accessories-title">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <Link
            to="/chair/core"
            className="inline-flex items-center text-black/60 hover:text-[#8E7AB5] mb-6 sm:mb-8 transition-colors cursor-pointer tracking-wide text-sm sm:text-base"
          >
            <i className="ri-arrow-left-line mr-2" aria-hidden="true"></i>
            Chair Coreに戻る
          </Link>
          <div className="text-center max-w-3xl mx-auto">
            <span className="inline-block px-3 sm:px-4 py-1.5 sm:py-2 bg-[#8E7AB5]/10 text-[#8E7AB5] text-xs sm:text-sm tracking-[0.1em] rounded-full mb-4 sm:mb-6">
              別売りオプション
            </span>
            <h1 id="accessories-title" className="text-3xl sm:text-4xl md:text-5xl font-extralight text-black mb-4 sm:mb-6 tracking-[0.05em] sm:tracking-[0.1em]">
              アクセサリー・オプション
            </h1>
            <p className="text-base sm:text-lg text-black/60 font-extralight leading-relaxed tracking-wide">
              MeVER Chairをさらに快適にするオプションパーツ。<br className="hidden sm:block" />
              お使いの環境や好みに合わせてカスタマイズできます。
            </p>
          </div>
        </div>
      </section>

      {/* Product Grid */}
      <section className="py-12 sm:py-16 bg-white" aria-labelledby="products-heading">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <h2 id="products-heading" className="sr-only">オプション製品一覧</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6" role="list">
            {accessoriesData.map((item) => (
              <button
                key={item.id}
                onClick={() => setSelectedAccessory(item)}
                className={`group text-left p-4 sm:p-5 rounded-xl sm:rounded-2xl border-2 transition-all cursor-pointer ${
                  selectedAccessory.id === item.id
                    ? 'border-[#8E7AB5] bg-[#8E7AB5]/5'
                    : 'border-gray-100 hover:border-[#8E7AB5]/30 bg-white'
                }`}
                role="listitem"
                aria-pressed={selectedAccessory.id === item.id}
              >
                <div className="relative aspect-square bg-gray-50 rounded-lg sm:rounded-xl overflow-hidden mb-3 sm:mb-4">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    width="300"
                    height="300"
                  />
                  {item.badge && (
                    <span className={`absolute top-2 right-2 px-2 py-1 text-xs font-light rounded-full ${
                      item.badge === 'セール' ? 'bg-red-500 text-white' : 'bg-[#8E7AB5] text-white'
                    }`}>
                      {item.badge}
                    </span>
                  )}
                </div>
                <h3 className="text-base sm:text-lg font-light text-black mb-1 tracking-wide">
                  {item.name}
                </h3>
                <div className="space-y-1">
                  <div className="flex items-center gap-2">
                    {item.priceGray && <span className="text-xs text-black/60">Black</span>}
                    <span className="text-lg sm:text-xl font-light text-black">{item.price}</span>
                    {item.originalPrice && (
                      <span className="text-sm text-black/40 line-through">{item.originalPrice}</span>
                    )}
                  </div>
                  {item.priceGray && (
                    <div className="flex items-center gap-2">
                      <span className="text-xs text-black/60">Gray</span>
                      <span className="text-lg sm:text-xl font-light text-black">{item.priceGray}</span>
                    </div>
                  )}
                </div>
                <span className={`inline-block mt-2 text-xs px-2 py-0.5 rounded-full ${
                  item.status === '在庫あり' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'
                }`}>
                  {item.status}
                </span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Selected Product Detail */}
      <section className="py-16 sm:py-20 bg-gray-50" aria-labelledby="detail-heading">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-10 sm:gap-12 lg:gap-16 items-start">
            {/* Image */}
            <div className="sticky top-24">
              <div className="aspect-square bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-sm">
                <img
                  src={selectedAccessory.image}
                  alt={selectedAccessory.name}
                  className="w-full h-full object-cover object-center"
                  loading="eager"
                  width="600"
                  height="600"
                />
              </div>
            </div>

            {/* Info */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                {selectedAccessory.badge && (
                  <span className={`px-3 py-1 text-xs font-light rounded-full ${
                    selectedAccessory.badge === 'セール' ? 'bg-red-500 text-white' : 'bg-[#8E7AB5] text-white'
                  }`}>
                    {selectedAccessory.badge}
                  </span>
                )}
                <span className={`px-3 py-1 text-xs rounded-full ${
                  selectedAccessory.status === '在庫あり' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'
                }`}>
                  {selectedAccessory.status}
                </span>
              </div>

              <h2 id="detail-heading" className="text-2xl sm:text-3xl md:text-4xl font-extralight text-black mb-3 sm:mb-4 tracking-[0.05em]">
                {selectedAccessory.name}
              </h2>

              <p className="text-base sm:text-lg text-black/60 font-extralight leading-relaxed mb-6 tracking-wide">
                {selectedAccessory.description}
              </p>

              <div className="mb-6">
                <div className="flex items-baseline gap-3 mb-2">
                  {selectedAccessory.priceGray && <span className="text-sm text-black/60">Black</span>}
                  <span className="text-3xl sm:text-4xl font-light text-black">{selectedAccessory.price}</span>
                  <span className="text-sm text-black/60">(税込)</span>
                  {selectedAccessory.originalPrice && (
                    <span className="text-lg text-black/40 line-through">{selectedAccessory.originalPrice}</span>
                  )}
                </div>
                {selectedAccessory.priceGray && (
                  <div className="flex items-baseline gap-3">
                    <span className="text-sm text-black/60">Gray</span>
                    <span className="text-3xl sm:text-4xl font-light text-black">{selectedAccessory.priceGray}</span>
                    <span className="text-sm text-black/60">(税込)</span>
                  </div>
                )}
              </div>

              {/* Compatibility */}
              <div className="mb-8 p-4 bg-white rounded-lg">
                <h3 className="text-sm font-light text-black/60 mb-2 tracking-wide">対応モデル</h3>
                <div className="flex flex-wrap gap-2">
                  {selectedAccessory.compatibility.map((model, index) => (
                    <span key={index} className="px-3 py-1.5 bg-gray-100 text-sm text-black rounded-full">
                      {model}
                    </span>
                  ))}
                </div>
              </div>

              {/* CTA */}
              <div className="flex flex-col sm:flex-row gap-3 mb-10">
                <a
                  href="https://mever.design/products"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 text-center px-8 py-4 bg-[#8E7AB5] text-white text-sm font-light tracking-[0.1em] hover:bg-[#7A6A9E] transition-colors whitespace-nowrap rounded-md cursor-pointer"
                >
                  購入する
                </a>
                <Link
                  to="/chair/core"
                  className="flex-1 text-center px-8 py-4 border border-black/20 text-black text-sm font-light tracking-[0.1em] hover:bg-black hover:text-white transition-colors whitespace-nowrap rounded-md cursor-pointer"
                >
                  Chair Coreと一緒に購入
                </Link>
              </div>

              {/* Features */}
              <div className="mb-10">
                <h3 className="text-lg sm:text-xl font-light text-black mb-4 tracking-wide">特徴</h3>
                <div className="grid grid-cols-2 gap-3 sm:gap-4">
                  {selectedAccessory.features.map((feature, index) => (
                    <div key={index} className="p-4 bg-white rounded-lg">
                      <div className="w-10 h-10 flex items-center justify-center bg-[#8E7AB5]/10 rounded-lg mb-3">
                        <i className={`${feature.icon} text-xl text-[#8E7AB5]`} aria-hidden="true"></i>
                      </div>
                      <h4 className="text-sm font-light text-black mb-1">{feature.title}</h4>
                      <p className="text-xs text-black/60 font-extralight">{feature.desc}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Specs */}
              <div>
                <h3 className="text-lg sm:text-xl font-light text-black mb-4 tracking-wide">仕様</h3>
                <div className="bg-white rounded-lg overflow-hidden">
                  <dl>
                    {selectedAccessory.specs.map((spec, index) => (
                      <div
                        key={index}
                        className={`flex justify-between items-center px-4 sm:px-5 py-3 sm:py-4 ${
                          index !== selectedAccessory.specs.length - 1 ? 'border-b border-gray-100' : ''
                        }`}
                      >
                        <dt className="text-sm text-black/60 font-extralight tracking-wide">{spec.label}</dt>
                        <dd className="text-sm text-black font-light tracking-wide">{spec.value}</dd>
                      </div>
                    ))}
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bundle Suggestion */}
      <section className="py-16 sm:py-20 bg-white" aria-labelledby="bundle-heading">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12">
          <div className="text-center mb-10 sm:mb-12">
            <h2 id="bundle-heading" className="text-2xl sm:text-3xl font-extralight text-black mb-3 tracking-[0.1em]">
              おすすめセット
            </h2>
            <p className="text-base text-black/60 font-extralight tracking-wide">
              Chair Coreと一緒に購入でさらにお得
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#8E7AB5]/5 to-[#8E7AB5]/10 rounded-2xl p-6 sm:p-8 md:p-10">
            <div className="grid md:grid-cols-3 gap-6 items-center">
              {/* Chair */}
              <div className="text-center">
                <div className="aspect-square bg-white rounded-xl overflow-hidden mb-4 max-w-[200px] mx-auto">
                  <img
                    src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/f4a7d90296f789d46c6753357c7a51a3.png"
                    alt="MeVER Chair Core"
                    className="w-full h-full object-cover"
                    loading="lazy"
                    width="200"
                    height="200"
                  />
                </div>
                <h3 className="text-base font-light text-black mb-1">MeVER Chair Core</h3>
                <p className="text-lg font-light text-black">¥79,200</p>
              </div>

              {/* Plus Icon */}
              <div className="flex justify-center">
                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm">
                  <i className="ri-add-line text-2xl text-[#8E7AB5]" aria-hidden="true"></i>
                </div>
              </div>

              {/* Headrest */}
              <div className="text-center">
                <div className="aspect-square bg-white rounded-xl overflow-hidden mb-4 max-w-[200px] mx-auto">
                  <img
                    src={accessoriesData[0].image}
                    alt="4Dヘッドレスト"
                    className="w-full h-full object-cover"
                    loading="lazy"
                    width="200"
                    height="200"
                  />
                </div>
                <h3 className="text-base font-light text-black mb-1">4Dヘッドレスト</h3>
                <p className="text-lg font-light text-black">¥4,950</p>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-[#8E7AB5]/20 text-center">
              <div className="flex items-center justify-center gap-4 mb-4">
                <span className="text-black/60 line-through text-lg">¥84,150</span>
                <span className="text-3xl sm:text-4xl font-light text-black">¥82,000</span>
                <span className="px-3 py-1 bg-red-500 text-white text-sm rounded-full">¥2,150 OFF</span>
              </div>
              <p className="text-sm text-black/60 mb-6">セット購入で2,150円お得！</p>
              <a
                href="https://mever.design/products"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-10 py-4 bg-[#8E7AB5] text-white text-sm font-light tracking-[0.1em] hover:bg-[#7A6A9E] transition-colors whitespace-nowrap rounded-md cursor-pointer"
              >
                セットで購入する
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 sm:py-20 bg-gray-50" aria-labelledby="faq-heading">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-12">
          <h2 id="faq-heading" className="text-2xl sm:text-3xl font-extralight text-black mb-10 text-center tracking-[0.1em]">
            よくある質問
          </h2>
          <div className="space-y-4">
            <details className="group bg-white rounded-lg">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <span className="text-base font-light text-black">ヘッドレストの取り付けは簡単ですか？</span>
                <i className="ri-add-line text-xl text-black/40 group-open:hidden" aria-hidden="true"></i>
                <i className="ri-subtract-line text-xl text-black/40 hidden group-open:block" aria-hidden="true"></i>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-black/60 font-extralight leading-relaxed">
                  はい、工具不要で簡単に取り付けられます。背もたれ上部の取り付け穴に差し込み、ノブを回して固定するだけです。取り付け時間は約2分程度です。
                </p>
              </div>
            </details>
            <details className="group bg-white rounded-lg">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <span className="text-base font-light text-black">他社製のチェアにも使えますか？</span>
                <i className="ri-add-line text-xl text-black/40 group-open:hidden" aria-hidden="true"></i>
                <i className="ri-subtract-line text-xl text-black/40 hidden group-open:block" aria-hidden="true"></i>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-black/60 font-extralight leading-relaxed">
                  ヘッドレストはMeVER Chair Core専用設計のため、他社製チェアには対応しておりません。ランバーサポートクッションやアームレストパッドは汎用的にお使いいただけます。
                </p>
              </div>
            </details>
            <details className="group bg-white rounded-lg">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <span className="text-base font-light text-black">返品・交換は可能ですか？</span>
                <i className="ri-add-line text-xl text-black/40 group-open:hidden" aria-hidden="true"></i>
                <i className="ri-subtract-line text-xl text-black/40 hidden group-open:block" aria-hidden="true"></i>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-black/60 font-extralight leading-relaxed">
                  商品到着後7日以内であれば、未使用・未開封の状態に限り返品・交換を承ります。初期不良の場合は、保証期間内であれば無償で交換いたします。
                </p>
              </div>
            </details>
            <details className="group bg-white rounded-lg">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <span className="text-base font-light text-black">キャスターの交換方法を教えてください</span>
                <i className="ri-add-line text-xl text-black/40 group-open:hidden" aria-hidden="true"></i>
                <i className="ri-subtract-line text-xl text-black/40 hidden group-open:block" aria-hidden="true"></i>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-black/60 font-extralight leading-relaxed">
                  既存のキャスターを引き抜き、新しいキャスターを差し込むだけで交換できます。工具は不要です。交換時はチェアを横に倒して作業すると安全です。
                </p>
              </div>
            </details>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
